var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGolfClub = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 149.175 182",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "inherit",
  d: "m148.311 8.692-22.173 35.503a5.65 5.65 0 0 1-3.209 2.432L51.77 165.92l-9.029 13.444s-23.784 7.72-34.765-3.258c-11.691-11.689-13.662-34.502 15.887-23.972.45.162.92.333 1.396.516 0 0 14.121 6.26 18.727 9.787l71.731-120.438c-.19-1.285.034-2.636.777-3.826l22.183-35.501a5.681 5.681 0 1 1 9.634 6.02",
  className: "golf-club_svg__svg-safari-fix"
})));
export default SvgGolfClub;